export interface UserflowOnboardingIds {
  freeAccountChecklistId: string;
  advancedPaidAccountChecklistId: string;
  paidAccountChecklistId: string;
}
